<template>
    <div class="register-wrap" >
        <div class="ms-register">
            <div class="ms-title">胖布丁后台管理系统</div>
            <el-form :model="param" :rules="rules" ref="registerForm" label-width="0px" class="ms-content">
                <el-form-item prop="nickname">
                    <el-input v-model="param.nickname" placeholder="昵称" >
                        <el-button slot="prepend" icon="el-icon-lx-profile"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="account">
                    <el-input v-model="param.account" placeholder="账号" >
                        <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="password" >
                    <el-input
                        auto-complete="new-password"
                        type="password"
                        placeholder="密码"
                        v-model="param.password"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <el-form-item prop="toPassword">
                    <el-input
                        type="password"
                        placeholder="确认密码"
                        v-model="param.toPassword"
                        @keyup.enter.native="submitForm()"
                    >
                        <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                    </el-input>
                </el-form-item>
                <div class="register-btn">
                    <el-button type="primary" @click="submitForm('registerForm')">注 册</el-button>
                </div>
                <div class="login-btn">
                    <el-button  @click="goLogin()">登录</el-button>
                </div>
            </el-form>
            
        </div>
    </div>
</template>

<script>
import { userAdminRegister } from '@api/dashboard';

export default {
    data: function() {
        var checkPassword = (rule, value, callback) => {
            if (!value) {
                callback()
            } else if (value !== this.param.password) {
                callback(new Error("两次输入的密码不一致"))
            }
            callback()
        }
        return {
            param: {
                nickname: '',
                account: '',
                password: '',
                toPassword: ''
            },
            rules: {
                nickname: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                account: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },

                    { pattern: /^[0-9A-Za-z_]{5,16}$/, message: '长度为5-16位, 不能含有特殊符号', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },

                    { min:8, max:16, message: '长度为8-16位', trigger: 'blur' }
                
                ],
                toPassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    
                    { validator: checkPassword, }
                ],
            },
        };
    },
    methods: {
        submitForm (registerForm) {
            this.$refs[registerForm].validate((valid) => {
                if (valid) {
                    let params = {"nickName": this.param.nickname, "account": this.param.account, "password": this.param.password};
                    userAdminRegister(params).then(res => {
                        if (res.code !== 200) {
                            this.$message.error(res.message)
                            return
                        }
                        this.$message.success('注册成功');
                    })
                }
            });
        },

        //前往登录页
        goLogin () {
            this.$router.push('/login');
        },
    },
};
</script>

<style scoped>

.register-wrap {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url('../../assets/img/background.jpg');
    background-size: cover;
}
.ms-title {
    width: 100%;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    border-bottom: 1px solid #ddd;
}
.ms-register {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 350px;
    margin: -190px 0 0 -175px;
    border-radius: 15px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}

.register-btn {
    text-align: center;
    
}
.register-btn button {
    border-radius: 6px;
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
    /* 添加过渡时间 1s */
    transition: 0.6s;
}


.login-btn button {
    text-align: center;
    font-size: 15px;
    text-decoration:underline;
    background-color:transparent;
    border: none;
    border-radius: 4px;
    margin-left: 213px;
    margin-bottom: -5px;
    /* 添加过渡时间 1s */
    transition: 0.6s;
}
</style>